module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/pimples-61ed5b190e522140eb06ac30acb485aa.png";